module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("c4VYt"))).then(() => module.bundle.root('hEqeo'));